import { tfsConfig } from './tfs';
import { collinsonConfig } from './collinson';
import { HOSTNAME_TO_TENANT } from './hostname-to-tenant-map';
import type { TenantConfig } from './types';

export type { TenantConfig };

export const TENANT_CONFIGS = {
  tfs: tfsConfig,
  collinson: collinsonConfig,
} as const;

export type TenantId = keyof typeof TENANT_CONFIGS;

export const DEFAULT_TENANT_ID: TenantId = 'tfs';

export function isValidTenantId(value: unknown): value is TenantId {
  return typeof value === 'string' && value in TENANT_CONFIGS;
}

export function getTenantIdFromHostname(): TenantId | undefined {
  const hostname = window.location.hostname;
  return HOSTNAME_TO_TENANT[hostname as keyof typeof HOSTNAME_TO_TENANT] as
    | TenantId
    | undefined;
}

export function getTenantConfig(tenantId: TenantId): TenantConfig {
  return TENANT_CONFIGS[tenantId];
}
